// extracted by mini-css-extract-plugin
export default {"desktop":"desktop__2hGjw","mobile":"mobile__Q8XHQ"};